export const environment = {
  production: true,
  envName: 'staging',
  apiUrl: 'https://api.dorado.dev.perare.io',
  mapUrl: 'https://map.sirius.dev.perare.io',
  wsUrl: 'wss://dorado.dev.perare.io/ws/',

  mapboxToken:
    'pk.eyJ1IjoibWFyaWlhbWFyaWlhIiwiYSI6ImNtcG56dHVrcTAwcW8ycnE1cTY3eWlvNTkifQ.BQnZbTIda-m2Y2LMoFpfaw',
  
  // Sentry DSN for perare-dev project (staging also uses dev)
  sentryDsn: 'https://73b048d01ea8436247111708eac94158@o4507607579426816.ingest.us.sentry.io/4509762309849088',

  metaPixelId: null as string | null,
  gtmContainerId: 'GTM-KTLBW9RL',
};
